import { render, staticRenderFns } from "./Primary_button.vue?vue&type=template&id=736c1652&scoped=true&"
import script from "./Primary_button.vue?vue&type=script&lang=js&"
export * from "./Primary_button.vue?vue&type=script&lang=js&"
import style0 from "./Primary_button.vue?vue&type=style&index=0&id=736c1652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736c1652",
  null
  
)

export default component.exports